import {Component, DestroyRef, Inject, inject, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DialogTextModel} from "../../../core/cms/models/dialog.text.model";
import {DialogRestService} from "../../../core/cms/services/dialog.rest.service";
import {finalize, take} from "rxjs/operators";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {LogService} from "../../../core/base/log.service";

@Component({
    selector: 'app-legal',
    templateUrl: './legal.component.html',
    styleUrls: ['./legal.component.scss'],
    standalone: false
})
export class LegalComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly log = inject(LogService);
  readonly saving = signal(false);
  readonly error = signal<string | null>(null);

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogTextModel,
              private dialogRestService: DialogRestService,
              public dialogRef: MatDialogRef<LegalComponent>) {
  }

  onAccept() {
    if (this.saving()) return;
    this.saving.set(true);
    this.error.set(null);
    this.dialogRestService.subscribeToDialogOffer(this.data.id, this.data.idf).pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef),
      finalize(() => this.saving.set(false))
    ).subscribe({
      next: res => {
        if (res.error_code !== null) {
          this.error.set('Die Zustimmung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
          this.log.error('Unable to accept legal popup', res.error_code);
          return;
        }
        this.dialogRef.close();
      },
      error: error => {
        this.error.set('Die Zustimmung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.');
        this.log.error('Unable to accept legal popup', error);
      }
    });
  }
}
